export default __webpack_public_path__ + "static/media/distanstolkning12.d568c675.png";